import axios from 'axios'
import { baseURL } from './config.js'
import qs from 'qs'

// 管理员
export default {
  getSBList(params) { // 获取设备列表
    const url =  baseURL + '/tbComputermanage/list';
    return axios.post(url, qs.stringify(params));
  },
  addSBList(params) { // 添加设备
    const url =  baseURL + '/tbComputermanage/modify';
    return axios.post(url, qs.stringify(params));
  },
  delSBList(params) { // 删除设备
    const url =  baseURL + '/tbComputermanage/delete';
    return axios.post(url, qs.stringify(params));
  },

  userList(params) { // 用户列表
    const url =  baseURL + '/tbUser/userListFront';
    return axios.post(url, qs.stringify(params));
  },
  addComList(params) { // 企业用户拉人
    const url =  baseURL + '/tbUser/companyManagerAddUser';
    return axios.post(url, qs.stringify(params));
  },
  delComUserList(params) { // 批量删除企业用户
    const url =  baseURL + '/tbUser/companyManagerRemoveUser';
    return axios.post(url, qs.stringify(params));
  },
  exportPointExcel(params) { // 导出
    const url =  baseURL + '/tbAuthorizedproduct/exportPointExcel';
    return url;
  },
  hardwareBinding(params){// 企业系统设置
    const url =  baseURL + '/tbCompany/hardwareBinding';
    return axios.post(url, qs.stringify(params));
  },
  getCompany(params){// 获取企业信息
    const url =  baseURL + '/tbCompany/getCompany';
    return axios.post(url, qs.stringify(params));
  },
  
  // 获取部门列表
  getDeptListByUserId(params){
    const url =  baseURL + '/tbDept/getDeptIdByUserId';
    return axios.post(url, qs.stringify(params));
  },

  // 根据企业id查询部门列表
  getDepartList(params) { 
    const url =  baseURL + '/tbDept/deptList';
    return axios.post(url, qs.stringify(params));
  }, 

   /**部门管理 **/
  
  // 查询部分下人员
  getCompanyUser(params) { 
    const url =  baseURL + '/tbUser/getCompanyUser';
    return axios.post(url, qs.stringify(params));
  }, 
  
  // 查询部门列表
  getDepartList(params) { 
    const url =  baseURL + '/tbDept/deptList';
    return axios.post(url, qs.stringify(params));
  }, 

  // 查询部门详情
  getDepartDetail(params) { 
    const url =  baseURL + '/tbDept/deptDetail';
    return axios.post(url, qs.stringify(params));
  }, 
 
  // 新增
  addDept(params) { 
    const url =  baseURL + '/tbDept/addDept';
    // return axios.post(url, params);
    return axios.post(url, qs.stringify(params));
  }, 

  // 编辑
  editDept(params) { 
    const url =  baseURL + '/tbDept/modifyDept';
    // return axios.post(url,params);
    return axios.post(url, qs.stringify(params));
  }, 

  // 删除部门
  delDepart(params) { 
    const url =  baseURL + '/tbDept/deptDelete';
    return axios.post(url, qs.stringify(params));
  }, 

  // 根据用户id获取部门列表
  getDeptListByUserId(params){
    const url =  baseURL + '/tbDept/getDeptIdByUserId';
    return axios.post(url, qs.stringify(params));
  },


  // 产品分配给部门
  dispatchProductToDepart(params){
    const url =  baseURL + '/tbAuthorizedproduct/auProToDeptManager';
    return axios.post(url, qs.stringify(params));
  },

   // 校验部门名称是否唯一
   checkDepartUnique(param) {
    const url = baseURL + '/tbDept/deptNameCheck?deptname='+ param.deptname +'&companyid='+param.companyid;
    return axios.post(url)
  },

  
  
  
}


// WEBPACK FOOTER //
// ./src/api/company.js